import { render, staticRenderFns } from "./StatementConvoAdd.vue?vue&type=template&id=2795a1b0&"
import script from "./StatementConvoAdd.vue?vue&type=script&lang=js&"
export * from "./StatementConvoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports